import JsonApiResource from './JsonApiResource'
import AnearEvent from './AnearEvent'

export default class AnearVenue extends JsonApiResource {
  get name() { return this.attributes.name }
  get title() { return this.attributes.title || this.attributes.name }
  get description() { return this.attributes.description || '' }
  get venuePhotoUrl() { return this.attributes['venue-photo-url'] || '' }
  get venuePhotoMediumUrl() { return this.attributes['venue-photo-medium-url'] || '' }
  get qrImageUrl() { return this.attributes['qr-image-url'] || '' }
  get scheduledAt() { return this.attributes['scheduled-at'] || null }
  get endsAt() { return this.attributes['ends-at'] || null }
  get timeZone() { return this.attributes['time-zone'] || null }
  get slug() { return this.attributes.slug }
  get state() { return this.attributes['effective-state'] || this.attributes['aasm-state'] }
  venueZoneAssignments = () => this.attributes['venue-zone-assignments'] || []

  events = () => {
    const relEvents = this.relationships?.events?.data || []
    return relEvents
      .map(rel => this.findIncluded({ data: rel }))
      .filter(Boolean)
      .map(eventData => new AnearEvent(eventData, this.included))
  }
}
